module.exports = __webpack_public_path__ + "img/img_exhibition_en.7c41b886.png";